import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';

class Autocomplete extends Component {
	state = {
		value: '',
		suggestions: []
	}

	getSuggestionValue = suggestion => suggestion.name;

	renderSuggestion = suggestion => (
		<div>
			{suggestion.name}
		</div>
	)

	onChange = (event, { newValue }) => {
		this.setState({
			value: newValue
		});
	}

	onSuggestionsFetchRequested = ({ value }) => {
		this.props.getSuggestions(value)
			.then(response => {
				if (response.success) {
					this.setState({
						suggestions: response.data
					});
				}
			})
			.catch(error => console.error(error));
	}

	onSuggestionsClearRequested = () => {
		this.setState({
			suggestions: []
		});
	}

	onSelect = (e, {suggestion}) => {
		this.props.onSelect(suggestion);
	}

	render () {
		const { value, suggestions } = this.state;

		const inputProps = {
			placeholder: 'Введите первые буквы в названии',
			value,
			onChange: this.onChange
		};

		return (
			<Autosuggest
				suggestions={suggestions}
				onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
				onSuggestionsClearRequested={this.onSuggestionsClearRequested}
				getSuggestionValue={this.getSuggestionValue}
				renderSuggestion={this.renderSuggestion}
				inputProps={inputProps}
				onSuggestionSelected={this.onSelect}
			/>
		);
	}
}

Autocomplete.propTypes = {
	getSuggestions: PropTypes.func.isRequired,
	onSelect: PropTypes.func.isRequired
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./components/Autocomplete.js